import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { localisation } from '@siza-staff-care/shared/app-state';

export const formatCurrencyValue = (value: number) => {
	const locale = localisation.locale;
	const currencyCode = localisation.currencyCode;

	const currencySymbol = getCurrencySymbol(currencyCode, 'wide', locale);

	return formatCurrency(value, locale, currencySymbol);
};
